import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const ImageRoot = styled(
  Box,
  { shouldForwardProp: (prop) => prop !== 'hideImage' },
)<{ hideImage?: boolean }>(({ hideImage, theme }) => ({
  margin: '0 auto',
  height: 350,
  backgroundColor: hideImage ? theme.palette.general.lightGrey5 : 'transparent',
  width: '80%',
  borderRadius: '8px',
}));
